export class DateRangePicker extends HTMLElement
{
    SELECT_NONE = -1;
    SELECT_START_DATE = 0;
    SELECT_END_DATE = 1;

    constructor ()
    {
        super();
    }

    connectedCallback ()
    {
        this.init();
    }

    get startDate ()
    {
        let dateRange = this.dataset.dateRange;
        console.assert(dateRange.includes('::'), 'Date Range Input does not contain a date range');
        dateRange = dateRange.split('::');
        return new Date(dateRange[0] + 'T00:00:00');
    }

    set startDate (startDate)
    {
        let dateRange = this.dataset.dateRange;
        console.assert(dateRange.includes('::'), 'Date Range Input does not contain a date range');
        dateRange = dateRange.split('::');
        dateRange[0] = startDate.toISOString().split('T')[0];
        this.dataset.dateRange = dateRange.join('::');

        const startDateInput = this.querySelector('.start-date-input');
        startDateInput.value = startDate.toISOString().split('T')[0];
    }

    get endDate ()
    {
        let dateRange = this.dataset.dateRange;
        console.assert(dateRange.includes('::'), 'Date Range Input does not contain a date range');
        dateRange = dateRange.split('::');
        return new Date(dateRange[1] + 'T00:00:00');
    }

    set endDate (endDate)
    {
        let dateRange = this.dataset.dateRange;
        console.assert(dateRange.includes('::'), 'Date Range Input does not contain a date range');
        dateRange = dateRange.split('::');
        dateRange[1] = endDate.toISOString().split('T')[0];
        this.dataset.dateRange = dateRange.join('::');

        const endDateInput = this.querySelector('.end-date-input');
        endDateInput.value = endDate.toISOString().split('T')[0];
    }

    get dateSelectionMode ()
    {
        const endDateInput = document.querySelector('input#end-date-input');
        const startDateInput = document.querySelector('input#start-date-input');
        if (endDateInput.dataset.active === 'true') {
            return this.SELECT_END_DATE;
        } else if (startDateInput.dataset.active === 'true') {
            return this.SELECT_START_DATE;
        } else {
            return this.SELECT_NONE;
        }
    }

    set dateSelectionMode (dateSelectionMode)
    {
        const startDateInput = document.querySelector('input#start-date-input');
        const endDateInput = document.querySelector('input#end-date-input');
        const headerSelectionMode = this.querySelector('.calendar-header-selection-mode');

        if (dateSelectionMode === this.SELECT_START_DATE) {
            startDateInput.dataset.active = 'true';
            endDateInput.dataset.active = 'false';
            headerSelectionMode.textContent = 'Select Start Date';
            headerSelectionMode.dataset.selectionMode = `${this.SELECT_START_DATE}`;
        } else if (dateSelectionMode === this.SELECT_END_DATE) {
            startDateInput.dataset.active = 'false';
            endDateInput.dataset.active = 'true';
            headerSelectionMode.textContent = 'Select End Date';
            headerSelectionMode.dataset.selectionMode = `${this.SELECT_END_DATE}`;
        } else {
            startDateInput.dataset.active = 'false';
            endDateInput.dataset.active = 'false';
            headerSelectionMode.textContent = 'Select Date Range';
            headerSelectionMode.dataset.selectionMode = `${this.SELECT_NONE}`;
            const dateRangeDateSelector = this.querySelector('date-range-date-selector');
            dateRangeDateSelector.style.display = 'none';
        }
    }

    init ()
    {
        this.initDateRange();
        if (this.querySelector('button.date-range-button') == null) {
            this.createPicker();
        }
        this.onWorkListLoaded(null);

        this.initEventListeners();
    }

    initDateRange ()
    {
        const dateRangeInput = this.parentElement.querySelector('input[data-filter="ScheduledDate"]');

        let dateRange = dateRangeInput.value;
        console.assert(dateRange.includes('::'), 'Date Range Input does not contain a date range');
        this.dataset.dateRange = dateRange;
    }

    createPicker ()
    {
        this.classList.add('date-range-picker');
        this.createButton();
        this.createDropDown();
    }

    createButton ()
    {
        const button = document.createElement('button');
        button.classList.add('btn', 'date-range-button');
        button.setAttribute('type', 'button');
        const calendarSpan = document.createElement('span');
        calendarSpan.classList.add('calendar-span-calendar');
        const icon = document.createElement('i');
        icon.classList.add('vetology-calendar');
        calendarSpan.appendChild(icon);
        button.appendChild(calendarSpan);
        const buttonText = document.createElement('span');
        buttonText.classList.add('calendar-span-text');
        buttonText.textContent = 'Select Date Range';
        button.appendChild(buttonText);
        const dropDownSpan = document.createElement('span');
        dropDownSpan.classList.add('calendar-span-dropdown');
        const dropDownIcon = document.createElement('i');
        dropDownIcon.classList.add('vetology-full-down');
        dropDownSpan.appendChild(dropDownIcon);
        button.appendChild(dropDownSpan);

        // set popup options
        button.dataset.trigger = 'manual';
        button.dataset.placement = 'bottom';
        button.dataset.toggle = 'popover';
        button.dataset.title = 'Date Range may need to be adjusted';
        button.dataset.html = true;
        button.dataset.content = "<div class='date-btn-popup'>If you are not seeing the results you expect, <br/>consider changing the date" +
            " range.</div>";


        this.appendChild(button);
    }

    createDropDown ()
    {
        const dropDown = document.createElement('div');
        dropDown.classList.add('date-range-picker-dropdown');
        dropDown.style.display = 'none';

        this.createDateList(dropDown);
        this.createDateRangeSelectorContainer(dropDown);
        this.appendChild(dropDown);
    }

    createDateList (dropDown)
    {
        const dateRangeListDiv = document.createElement('div');
        dateRangeListDiv.classList.add('date-range-list-container');
        const dateRangeList = document.createElement('ul');
        dateRangeList.classList.add('date-range-list');
        this.populateDateRangeList(dateRangeList);
        dateRangeListDiv.appendChild(dateRangeList);
        dropDown.appendChild(dateRangeListDiv);
    }

    populateDateRangeList (dateRangeList)
    {
        let dateListItems = this.dataset.dateRangeList;
        try {
            dateListItems = JSON.parse(dateListItems);
        } catch (e) {
            console.log(e);
        }

        // iterate over items object and create list items
        for (const property in dateListItems) {
            if (dateListItems.hasOwnProperty(property)) {
                const dateListItem = document.createElement('li');
                dateListItem.classList.add('date-range-list-item');
                const dateListItemButton = document.createElement('button');
                dateListItemButton.classList.add('date-picker-date-list-item-button');
                dateListItemButton.setAttribute('type', 'button');
                dateListItemButton.setAttribute('data-value', dateListItems[property]);
                dateListItemButton.textContent = property;
                dateListItem.appendChild(dateListItemButton);
                dateRangeList.appendChild(dateListItem);
            }
        }

        // if we have items, then add the custom button
        if (Object.keys(dateListItems).length > 0) {
            const dateListItem = document.createElement('li');
            dateListItem.classList.add('date-range-list-item');
            const dateListItemButton = document.createElement('button');
            dateListItemButton.classList.add('date-picker-date-list-item-button', 'date-picker-custom-date-button');
            dateListItemButton.setAttribute('type', 'button');
            dateListItemButton.dataset.value = 'custom';
            dateListItemButton.textContent = 'Custom Date Range';
            dateListItem.appendChild(dateListItemButton);
            dateRangeList.appendChild(dateListItem);
        }
    }

    createDateRangeSelectorContainer (dropDown)
    {
        const dateRangeSelectionContainer = document.createElement('div');
        dateRangeSelectionContainer.classList.add('date-range-selection-container');
        const dateRangeSelectionHeader = document.createElement('div');
        dateRangeSelectionHeader.classList.add('date-range-selection-header');
        this.createDateRangeSelectionHeader(dateRangeSelectionHeader);

        dateRangeSelectionContainer.appendChild(dateRangeSelectionHeader);
        dateRangeSelectionContainer.appendChild(this.createCancelApplyButtons());

        const dateRangeDateSelector = this.createDateRangeDateSelector();

        dateRangeSelectionContainer.appendChild(dateRangeDateSelector);
        dropDown.appendChild(dateRangeSelectionContainer);

    }

    createDateRangeSelectionHeader (dateRangeSelectionHeader)
    {
        // create start and end date inputs
        const startDateFormGroup = document.createElement('div');
        startDateFormGroup.classList.add('form-control-group', 'start-date-form-control-group');
        const startDateLabel = document.createElement('label');
        startDateLabel.classList.add('form-control-label');
        startDateLabel.setAttribute('for', 'start-date-input');
        startDateLabel.textContent = 'Start Date';
        startDateFormGroup.appendChild(startDateLabel);
        const startDateInput = document.createElement('input');
        startDateInput.classList.add('form-control', 'start-date-input');
        startDateInput.setAttribute('type', 'date');
        startDateInput.setAttribute('id', 'start-date-input');
        startDateInput.setAttribute('name', 'start-date-input');
        startDateInput.setAttribute('placeholder', 'Start Date');
        startDateFormGroup.appendChild(startDateInput);
        dateRangeSelectionHeader.appendChild(startDateFormGroup);

        const endDateFormGroup = document.createElement('div');
        endDateFormGroup.classList.add('form-control-group', 'end-date-form-control-group');
        const endDateLabel = document.createElement('label');
        endDateLabel.classList.add('form-control-label');
        endDateLabel.setAttribute('for', 'end-date-input');
        endDateLabel.textContent = 'End Date';
        endDateFormGroup.appendChild(endDateLabel);
        const endDateInput = document.createElement('input');
        endDateInput.classList.add('form-control', 'end-date-input');
        endDateInput.setAttribute('type', 'date');
        endDateInput.setAttribute('id', 'end-date-input');
        endDateInput.setAttribute('name', 'end-date-input');
        endDateInput.setAttribute('placeholder', 'End Date');
        endDateFormGroup.appendChild(endDateInput);
        dateRangeSelectionHeader.appendChild(endDateFormGroup);

    }

    createCancelApplyButtons ()
    {
        const cancelApplyButtons = document.createElement('div');
        cancelApplyButtons.classList.add('cancel-apply-buttons');
        const cancelButton = document.createElement('button');
        cancelButton.classList.add('btn', 'cancel-button');
        cancelButton.textContent = 'Cancel';
        const applyButton = document.createElement('button');
        applyButton.classList.add('btn', 'btn-primary', 'apply-button');
        applyButton.textContent = 'Apply';
        cancelApplyButtons.appendChild(cancelButton);
        cancelApplyButtons.appendChild(applyButton);

        return cancelApplyButtons;
    }

    onCancelButtonClick (event)
    {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const dateRangeSelectionContainer = this.querySelector('.date-range-selection-container');
        dateRangeSelectionContainer.style.display = 'none';
        this.dateSelectionMode = this.SELECT_NONE;
    }

    onApplyButtonClick (event)
    {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const dateRangePicker = this.closest('date-range-picker');
        const startDateInput = dateRangePicker.querySelector('input#start-date-input');
        const endDateInput = dateRangePicker.querySelector('input#end-date-input');
        startDateInput.value = this.startDate.toISOString().split('T')[0];
        endDateInput.value = this.endDate.toISOString().split('T')[0];
        const dateRangeInput = document.querySelector('input[data-filter="ScheduledDate"]');
        dateRangeInput.value = this.dataset.dateRange;
        const changeEvent = new Event('change');
        dateRangeInput.dispatchEvent(changeEvent);
        const dateRangeSelectionContainer = this.querySelector('.date-range-selection-container');
        dateRangeSelectionContainer.style.display = 'none';
        const dateRangePickerDropdown = this.querySelector('.date-range-picker-dropdown');
        dateRangePickerDropdown.style.display = 'none';
        this.dateSelectionMode = this.SELECT_NONE;
        $(".isFilter[data-filter='Modality']").trigger("change");

    }

    createDateRangeDateSelector ()
    {
        return document.createElement('date-range-date-selector');
    }

    initEventListeners ()
    {
        // range button click
        const dateRangeList = this.querySelector('.date-range-list');
        dateRangeList.addEventListener('click', this.onDateRangeListClick.bind(this));

        // date range date selector change
        const startDateInput = this.querySelector('.start-date-input');
        startDateInput.addEventListener('click', this.onStartDateInputClick.bind(this));

        const endDateInput = this.querySelector('.end-date-input');
        endDateInput.addEventListener('click', this.onEndDateInputClick.bind(this));

        // date range button click
        const dateRangeButton = this.querySelector('.date-range-button');
        dateRangeButton.addEventListener('click', this.onDateRangeButtonClick.bind(this));

        // apply and cancel buttons
        const applyButton = this.querySelector('.apply-button');
        applyButton.addEventListener('click', this.onApplyButtonClick.bind(this));

        const cancelButton = this.querySelector('.cancel-button');
        cancelButton.addEventListener('click', this.onCancelButtonClick.bind(this));

        // for dismissing date range picker
        document.addEventListener('click', this.onDocumentClick.bind(this));

        // check for work list loaded
        document.addEventListener('work-list-loaded', this.onWorkListLoaded.bind(this));
    }

    clearFilters()
    {
        const dateRangeSelectionContainer = this.querySelector('.date-range-selection-container');
        dateRangeSelectionContainer.style.display = "none";

        this.initDateRange();

        this.updateDateRangeSelectionHeader();

    }

    onWorkListLoaded ()
    {
        // show the current date range on the date range picker button
        const dateRangeButton = this.querySelector('.date-range-button');
        const buttonTextSpan = dateRangeButton.querySelector('.calendar-span-text');
        const dateRangeInput = document.querySelector('input[data-filter="ScheduledDate"]');
        const dateRange = dateRangeInput.value;

        const dateRangeList = this.dataset.dateRangeList;
        if (this.isJson(dateRangeList)) {
            const dateRangeList = JSON.parse(this.dataset.dateRangeList);
            if (typeof dateRangeList === 'object') {
                const revertedList = [];
                for (const [key, value] of Object.entries(dateRangeList)) {

                    revertedList[value] = key;
                }

                if (dateRange in revertedList) {
                    buttonTextSpan.textContent = revertedList[dateRange];
                } else { // custom date range
                    // get the actual custom date range
                    const startDate = this.startDate.toDateString();
                    const endDate = this.endDate.toDateString();
                    buttonTextSpan.textContent = `${startDate} - ${endDate}`;

                }

                // highlight the list item
                this.clearDateRangeListSelection();
                const dateRangeText = buttonTextSpan.textContent;
                const dateRangeListItems = this.querySelectorAll('ul.date-range-list .date-range-list-item button');
                let found = false;
                for (const dateRangeListItem of dateRangeListItems) {
                    if (dateRangeListItem.textContent === dateRangeText) {
                        dateRangeListItem.classList.add('active');
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    const customDateRangeButton = this.querySelector('ul.date-range-list .date-range-list-item button[data-value="custom"]');
                    customDateRangeButton.classList.add('active');
                }
            }
        }

    }

    clearDateRangeListSelection ()
    {
        const dateRangeListItems = this.querySelectorAll('ul.date-range-list .date-range-list-item button');
        for (const dateRangeListItem of dateRangeListItems) {
            dateRangeListItem.classList.remove('active');
        }
    }


    isJson(str)
    {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    onDateRangeButtonClick(event)
    {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const dateRangeSelectionContainer = this.querySelector('.date-range-picker-dropdown');

        if (dateRangeSelectionContainer.style.display === 'none') {
            dateRangeSelectionContainer.style.display = 'flex';
        } else {
            dateRangeSelectionContainer.style.display = 'none';
        }
    }

    onDocumentClick(event)
    {
        const dateRangeSelectionContainer = this.querySelector('.date-range-picker-dropdown');
        if (event.target.closest('date-range-picker') === null) {
            dateRangeSelectionContainer.style.display = 'none';
        }
    }

    onStartDateInputClick(event)
    {
        event.preventDefault();
        this.dateSelectionMode = this.SELECT_START_DATE;
        this.displayDateRangeCalendars();
    }

    onEndDateInputClick(event)
    {
        event.preventDefault();
        this.dateSelectionMode = this.SELECT_END_DATE;
        this.displayDateRangeCalendars();
    }

    displayDateRangeCalendars()
    {
        const dateRangeDateSelector = this.querySelector('date-range-date-selector');
        dateRangeDateSelector.appendChild(dateRangeDateSelector.createDateCalendars());
        dateRangeDateSelector.highlightDateRange();
        dateRangeDateSelector.style.display = 'flex';
        dateRangeDateSelector.style.flexDirection = 'column';

    }
    onDateRangeListClick(event)
    {
        const target = event.target;
        if (target.classList.contains('date-picker-date-list-item-button')) {
            const value = target.dataset.value;
            if (value === 'custom') {
                this.showCustomDateRangeSelector();
                this.clearDateRangeListSelection();
                target.classList.add('active');
            } else {
                this.hideCustomDateRangeSelector();
                const dateRange = value.split('::');
                this.startDate = new Date(dateRange[0]);
                if (dateRange.length > 1) {
                    this.endDate = new Date(dateRange[1]);
                }

                const dateRangeInput = document.querySelector('input[data-filter="ScheduledDate"]');
                dateRangeInput.value = this.dataset.dateRange;

                this.updateDateRangeSelectionHeader();
                const dateRangePickerDropdown = this.querySelector('.date-range-picker-dropdown');
                dateRangePickerDropdown.style.display = 'none';
                $('.isFilter[data-filter="Modality"]').trigger('change');
            }
        }
    }

    updateDateRangeSelectionHeader()
    {
        const startDateInput = this.querySelector('.start-date-input');
        const endDateInput = this.querySelector('.end-date-input');
        startDateInput.value = this.startDate.toISOString().split('T')[0];
        endDateInput.value = this.endDate.toISOString().split('T')[0];
    }

    showCustomDateRangeSelector()
    {
        const dateRangeSelectionContainer = this.querySelector('.date-range-selection-container');
        dateRangeSelectionContainer.style.display = 'inline-flex';
    }

    hideCustomDateRangeSelector()
    {
        const dateRangeSelectionContainer = this.querySelector('.date-range-selection-container');
        dateRangeSelectionContainer.style.display = 'none';
    }

    isValidDate(d)
    {
        return d instanceof Date && !isNaN(d);
    }

}

customElements.define('date-range-picker', DateRangePicker);